import { Component, Prop } from "vue-property-decorator";
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { EquipmentSelectionType } from '@/enums/EquipmentSelectionType';

import { intersection, indexOf } from 'lodash-es';

interface ClientDeadlineItem {
	date?: Date;
	showToday?: boolean;
	future?: boolean;
}

@Block() @Component
export class ApartmentClientChangesDeadlinesBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	todayDate: Date = new Date();
	expand: boolean = !this.$store.isTouchDevice;
	allAfterDeadline: boolean = false;
	showDeadline = true;
	showDeadlineTooltip: boolean[] = [false, false, false, false];
	isTouchDevice: boolean = this.$store.isTouchDevice;

	get items(): ClientDeadlineItem[] {
		let items: ClientDeadlineItem[] = this.apartment.clientChangesDeadlines.map(deadline => {
			return { date: deadline ? new Date(deadline) : null };
		});

		if (!items[items.length - 1].date) {
			items.splice(-1, 1);
		}

		if (items.find(f => f.date !== null)) {
			const todayIndex = this.getIndexByDate(items, this.todayDate);
			if (todayIndex > -1 && todayIndex < items.length - 1) {
				items[todayIndex].showToday = true;
			}

			items.slice(todayIndex + 1).forEach(item => (item.future = true));

			this.allAfterDeadline = !items.find(f => f.future);
		} else {
			this.showDeadline = false;
		}

		return items;
	}

	get isFloorsOrDoorsSelected() {
		return intersection(this.apartment.equipmentSelections.filter(es => es.selectionDate).map(es => es.type), [EquipmentSelectionType.Floors, EquipmentSelectionType.InnerDoors]).length > 0;
	}

	getIndexByDate(items: ClientDeadlineItem[], date?: Date) {
		let index = items.length - 1;
		while (index >= 0) {
			if (items[index].date && date && items[index].date < date) {
				break;
			}
			--index;
		}

		return index;
	}

	showTooltip(index: number) {
		if (indexOf(this.showDeadlineTooltip, true) != index) {
			this.showDeadlineTooltip = [false, false, false, false];
			this.showDeadlineTooltip[index] = true;
		} else {
			this.showDeadlineTooltip = [false, false, false, false];
		}
	}

	//created() {
	//	const mql = window.matchMedia("(pointer: coarse)");

	//	this.expand = !mql.matches
	//	this.isTouchDevice = mql.matches
	//}
}

export default ApartmentClientChangesDeadlinesBlock;
